"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnualMotorSummaryPagePremiumWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var services_1 = require("@falcon/services");
var core_1 = require("@athena-portal/core");
var commonFunctions_1 = require("../../../commonFunctions");
var components_1 = require("@athena-portal/components");
var AnnualMotorMtaExcessChangeBanner_1 = require("../../../components/annual/motor/AnnualMotorMtaExcessChangeBanner");
var react_html_parser_1 = require("react-html-parser");
var journey_services_1 = require("@athena-portal/journey-services");
var AnnualMotorSummaryPagePremiumWidget = /** @class */ (function (_super) {
    __extends(AnnualMotorSummaryPagePremiumWidget, _super);
    function AnnualMotorSummaryPagePremiumWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.getRenewalPremiumWording = function () {
            var hasPendingRenewal = _this.verifyRenewalProposalStatus(services_1.POLICY_STATUS_PENDING_RENEWAL);
            var previousRenewalPrice = hasPendingRenewal ? _this.state.renewalProposal.factors.annualPremium : 0;
            var currentRenewalPrice = _this.props.interaction.uistate.totalRenewalAmount;
            if (!hasPendingRenewal) {
                return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
            }
            if (previousRenewalPrice === currentRenewalPrice) {
                return (0, jsx_runtime_1.jsxs)("p", { className: "font-weight-semi-bold mb-0 margin-top-32", children: ["Your renewal price has also stayed the same at ", (0, commonFunctions_1.getAmountToDisplay)(currentRenewalPrice)] });
            }
            else {
                return (0, jsx_runtime_1.jsxs)("p", { className: "font-weight-semi-bold mb-0 margin-top-32", children: ["Your renewal price has changed from ", (0, commonFunctions_1.getAmountToDisplay)(previousRenewalPrice), " to ", (0, commonFunctions_1.getAmountToDisplay)(currentRenewalPrice), "."] });
            }
        };
        _this.renderPremiumPanel = function (interaction, changesStartDate, additionalWording, mtaJourney) {
            var hasDebtAndIsChangeAddressMTA = interaction.factors.debtAmount > 0 && interaction.process === services_1.INTERACTION_PROCESS_MTA_CHANGE_ADDRESS;
            var additionalPremium;
            var returnPremium;
            var paymentRequired;
            var refundRequired;
            if (hasDebtAndIsChangeAddressMTA) {
                additionalPremium = (0, commonFunctions_1.getAmountToDisplay)(interaction.factors.mtaAndDebtCombinedAdditionalAmount);
                returnPremium = (0, commonFunctions_1.getAmountToDisplay)(interaction.factors.mtaAndDebtCombinedReturnAmount);
                paymentRequired = interaction.factors.mtaAndDebtCombinedAdditionalAmount > 0;
                refundRequired = interaction.factors.mtaAndDebtCombinedReturnAmount > 0;
            }
            else {
                additionalPremium = (0, commonFunctions_1.getAmountToDisplay)(interaction.factors.additionalPremium);
                returnPremium = (0, commonFunctions_1.getAmountToDisplay)(interaction.factors.returnPremium);
                paymentRequired = interaction.factors.additionalPremium > 0;
                refundRequired = interaction.factors.returnPremium > 0;
            }
            var price = refundRequired ? "".concat(returnPremium, " refund") : additionalPremium;
            var renewalDecline = interaction.uistate.declineRenewal;
            var renewalWindowWording = _this.getRenewalPremiumWording();
            var premiumSpecificWording;
            if (paymentRequired) {
                premiumSpecificWording = (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["You'll pay an additional ", additionalPremium] });
            }
            else if (refundRequired) {
                premiumSpecificWording = (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["You'll receive a pro rata refund of ", returnPremium] });
            }
            else {
                premiumSpecificWording = (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: "There is no change in price" });
            }
            var paymentPanelOutputAdminFeeHtml = _this.getSetting("paymentPanelOutputAdminFeeHtml");
            return ((0, jsx_runtime_1.jsxs)("div", { className: "panel text-center mb-4 policy-change-price", children: [renewalDecline &&
                        (0, jsx_runtime_1.jsx)("p", { className: "ml-1 mb-1 warning-banner banner-warn additional-warning margin-top-0 margin-bottom-0", children: "Due to this change, if you continue you won't be able to renew at the end of your policy. You can make this change now (you'll be covered until your policy end date) or cancel the changes to allow the policy to renew." }), _this.getExcessBanner(interaction, mtaJourney), (0, jsx_runtime_1.jsx)("p", { className: "price font-weight-bold margin-bottom-16", children: price }), (0, jsx_runtime_1.jsx)("p", { className: "margin-bottom-32", children: "All figures include Insurance Premium Tax" }), (0, jsx_runtime_1.jsxs)("p", { className: "m-0", children: [premiumSpecificWording, " for the changes you have made from the ", changesStartDate, " to the end of your policy.", interaction.factors.adminFeeCharged && paymentPanelOutputAdminFeeHtml && _this.renderHtml(paymentPanelOutputAdminFeeHtml), additionalWording, !renewalDecline && renewalWindowWording] }), (!hasDebtAndIsChangeAddressMTA) && paymentRequired && _this.getUpfrontWording(interaction)] }));
        };
        _this.renderRenewalProposalPremiumPanel = function (interaction, changesStartDate, additionalWording, mtaJourney) {
            var _a, _b, _c, _d;
            var currentRenewalPrice = interaction.factors.annualPremium;
            var currentTotalPremium = interaction.paymentDetails.instalmentPlan.totalAmount;
            var currentMonthlyPayment = interaction.paymentDetails.instalmentPlan.monthlyPayment;
            var renewalProposal = _this.state.renewalProposal;
            var hasPendingRenewal = _this.verifyRenewalProposalStatus(services_1.POLICY_STATUS_PENDING_RENEWAL);
            var previousRenewalPrice = hasPendingRenewal ? (_a = renewalProposal.factors.annualPremium) !== null && _a !== void 0 ? _a : 0 : 0;
            var previousRenewalMonthlyPrice = hasPendingRenewal ? (_d = (_c = (_b = renewalProposal.paymentDetails) === null || _b === void 0 ? void 0 : _b.instalmentPlan) === null || _c === void 0 ? void 0 : _c.monthlyPayment) !== null && _d !== void 0 ? _d : 0 : 0;
            var isMonthlyPayment = interaction.factors.premiumType === services_1.PremiumType.monthly;
            var priceChange;
            if (isMonthlyPayment) {
                priceChange = "".concat((0, commonFunctions_1.getAmountToDisplay)(previousRenewalMonthlyPrice), " / month\n                            to ").concat((0, commonFunctions_1.getAmountToDisplay)(currentMonthlyPayment), " / month");
            }
            else {
                priceChange = "".concat((0, commonFunctions_1.getAmountToDisplay)(previousRenewalPrice), " to ").concat((0, commonFunctions_1.getAmountToDisplay)(currentRenewalPrice));
            }
            var premiumSpecificWording;
            var noPriceChange = false;
            if (currentRenewalPrice > previousRenewalPrice) {
                premiumSpecificWording = (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["has increased from ", priceChange, "."] });
            }
            else if (currentRenewalPrice < previousRenewalPrice) {
                premiumSpecificWording = (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["has reduced from ", priceChange, "."] });
            }
            else {
                premiumSpecificWording = (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: "has not changed." });
                noPriceChange = !noPriceChange;
            }
            return ((0, jsx_runtime_1.jsxs)("div", { className: "panel text-center mb-4 policy-change-price", children: [_this.getExcessBanner(interaction, mtaJourney), noPriceChange && (0, jsx_runtime_1.jsx)("p", { className: "font-weight-bold margin-bottom-32", children: "Great news! Your renewal price has stayed the same." }), (0, jsx_runtime_1.jsxs)("p", { className: "m-0", children: ["Your ", !noPriceChange && (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: "updated" }), " renewal price is ", (0, jsx_runtime_1.jsx)("strong", { children: (0, commonFunctions_1.getAmountToDisplay)(currentRenewalPrice) })] }), isMonthlyPayment && (0, jsx_runtime_1.jsxs)("p", { className: "margin-bottom-16", children: ["As you've chosen to pay monthly your monthly instalments will be", ' ', (0, commonFunctions_1.getAmountToDisplay)(currentMonthlyPayment), ". The total you will pay including interest is ", (0, commonFunctions_1.getAmountToDisplay)(currentTotalPremium), "."] }), (0, jsx_runtime_1.jsx)("p", { className: "margin-bottom-32", children: "All figures include Insurance Premium Tax" }), (0, jsx_runtime_1.jsxs)("p", { className: "m-0", children: ["Following the changes you've made to take effect from your renewal date (", changesStartDate, "), your renewal price ", premiumSpecificWording] }), additionalWording && (0, jsx_runtime_1.jsx)("p", { className: "margin-top-32 margin-bottom-0", children: additionalWording })] }));
        };
        _this.getAdditionalWording = function (interaction, mtaJourney) {
            var mtaSpecificWording = _this.getMTASpecificWording(interaction, mtaJourney);
            var tierChangeWording = _this.getTierChangeWording(interaction);
            var hasDebtAndIsChangeAddressMTA = interaction.factors.debtAmount > 0 && interaction.process === services_1.INTERACTION_PROCESS_MTA_CHANGE_ADDRESS;
            var debtAmount = (0, commonFunctions_1.getAmountToDisplay)(interaction.factors.debtAmount);
            if (hasDebtAndIsChangeAddressMTA) {
                return (0, jsx_runtime_1.jsxs)("p", { className: "margin-top-16", children: ["This takes into account the outstanding payment of ", debtAmount, " we didn't receive this month."] });
            }
            else if (mtaSpecificWording !== null || tierChangeWording !== "") {
                return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [' ', "You have chosen to:", (0, jsx_runtime_1.jsxs)("ul", { className: "m-0", children: [mtaSpecificWording, tierChangeWording && (0, jsx_runtime_1.jsx)("li", { children: tierChangeWording })] })] }));
            }
            else {
                return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
            }
        };
        _this.getMTASpecificWording = function (interaction, mtaJourney) {
            switch (mtaJourney) {
                case services_1.INTERACTION_PROCESS_MTA_REPLACE_CAR:
                case services_1.INTERACTION_PROCESS_SUPPORT_PORTAL_MTA_REPLACE_CAR:
                    return _this.getReplaceCarWording(interaction);
                case services_1.INTERACTION_PROCESS_MTA_ADD_PERMANENT_DRIVER:
                case services_1.INTERACTION_PROCESS_SUPPORT_PORTAL_ADD_ADDITIONAL_DRIVER:
                    return _this.getAddDriverWording(interaction);
                case services_1.INTERACTION_PROCESS_MTA_REMOVE_DRIVER:
                case services_1.INTERACTION_PROCESS_SUPPORT_PORTAL_REMOVE_DRIVER:
                    return _this.getRemoveDriverWording(interaction);
                default:
                    return null;
            }
        };
        _this.getReplaceCarWording = function (interaction) {
            var car = interaction.vehicles[0];
            var regNumber = car.registrationNumber ? ", (".concat(car.registrationNumber, ")") : '';
            var newCarWording = "".concat(car.make, ", ").concat(car.model).concat(regNumber);
            var oldCar = _this.state.oldInteraction.vehicles[0];
            var oldRegNumber = oldCar.registrationNumber ? ", (".concat(oldCar.registrationNumber, ")") : '';
            var oldCarWording = "".concat(oldCar.make, ", ").concat(oldCar.model).concat(oldRegNumber);
            var addedDrivers = _this.state.replaceCarAddedDrivers.length > 0 ?
                (0, jsx_runtime_1.jsxs)("li", { children: ["Add ", _this.state.replaceCarAddedDrivers, " to ", newCarWording] }) : (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
            var removedDrivers = _this.state.replaceCarRemovedDrivers.length > 0 ?
                (0, jsx_runtime_1.jsxs)("li", { children: ["Remove ", _this.state.replaceCarRemovedDrivers, " from ", newCarWording] }) : (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
            return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("li", { children: ["Replace ", oldCarWording, " with ", newCarWording] }), addedDrivers, removedDrivers] }));
        };
        _this.setReplaceCarSessionValues = function () {
            var oldVehicle = _this.state.oldInteraction.vehicles[0];
            window.sessionStorage.setItem("oldCarVrn", oldVehicle["make"]);
            window.sessionStorage.setItem("oldCarMake", oldVehicle["model"]);
            window.sessionStorage.setItem("oldCarModel", oldVehicle["registrationNumber"]);
        };
        _this.calculateReplaceCarAddedAndRemovedDrivers = function () {
            var _a = services_1.CommonHelpers.getRemovedAndAddedDrivers(_this.props.interaction.additionalDrivers), addedDrivers = _a.addedDrivers, removedDrivers = _a.removedDrivers;
            _this.setState({
                replaceCarAddedDrivers: addedDrivers,
                replaceCarRemovedDrivers: removedDrivers
            });
        };
        _this.state = {
            oldInteraction: {},
            dataLoaded: false,
            replaceCarRemovedDrivers: [],
            replaceCarAddedDrivers: [],
            renewalProposal: undefined,
            remainingAmountPresent: false
        };
        _this.isReplaceCarJourney = _this.getSetting("isReplaceCarJourney", false);
        return _this;
    }
    AnnualMotorSummaryPagePremiumWidget.prototype.componentDidMount = function () {
        var _this = this;
        this.customerPortalService.getPolicy(this.props.engine.getInteraction().agreementNumber).subscribe(function (policy) {
            _this.setState({
                oldInteraction: policy.interaction
            }, function () {
                _this.customerPortalService.getRenewalProposal(policy.policyNumber).subscribe(function (renewalProposal) {
                    _this.setState({
                        renewalProposal: renewalProposal,
                        dataLoaded: true
                    });
                });
                if (_this.isReplaceCarJourney) {
                    _this.setReplaceCarSessionValues();
                    _this.calculateReplaceCarAddedAndRemovedDrivers();
                }
                var agreementVersionIds = policy.policyHistoryList.map(function (ph) { return ph.id; });
                _this.customerPortalService.getCombinedInstalmentsInfo(agreementVersionIds)
                    .subscribe(function (instalmentsInfo) {
                    var remainingAmountPresent = Math.abs(instalmentsInfo === null || instalmentsInfo === void 0 ? void 0 : instalmentsInfo.remainingAmount) !== 0;
                    _this.setState({
                        remainingAmountPresent: remainingAmountPresent
                    });
                });
            });
        });
    };
    AnnualMotorSummaryPagePremiumWidget.prototype.render = function () {
        var interaction = this.props.engine.getInteraction();
        if (this.state.dataLoaded) {
            var tierEligibility_1 = interaction.tierEligibility;
            var tierAvailable = function (requiredTier) {
                return !!(tierEligibility_1 === null || tierEligibility_1 === void 0 ? void 0 : tierEligibility_1[requiredTier]);
            };
            if (interaction.factors && this.state.oldInteraction.factors && tierAvailable("coverTier")) {
                var changesStartDate = (0, commonFunctions_1.formatDateDMY)(interaction.headerInfo.startDate);
                var isRenewalProposal = this.props.interaction.status === services_1.POLICY_STATUS_PENDING_RENEWAL_PENDING_UPDATE;
                var mtaJourney = isRenewalProposal ? this.getSetting("referrerJourney") : interaction.process;
                var additionalWording = this.getAdditionalWording(interaction, mtaJourney);
                if (isRenewalProposal) {
                    return this.renderRenewalProposalPremiumPanel(interaction, changesStartDate, additionalWording, mtaJourney);
                }
                else {
                    return this.renderPremiumPanel(interaction, changesStartDate, additionalWording, mtaJourney);
                }
            }
            return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
        }
        else {
            return (0, jsx_runtime_1.jsx)(components_1.Overlay, { show: true });
        }
    };
    AnnualMotorSummaryPagePremiumWidget.prototype.renderHtml = function (htmlText) {
        return (0, react_html_parser_1.default)(this.renderTemplate(htmlText, true), {
            transform: function (node) {
                if (node.name === 'script' || node.name === 'style' || node.name === 'link') {
                    return null;
                }
                return undefined;
            }
        });
    };
    AnnualMotorSummaryPagePremiumWidget.prototype.renderTemplate = function (template, escapeFields) {
        return journey_services_1.ExpressionEvaluator.renderTemplate(template, this.props.interaction, escapeFields);
    };
    AnnualMotorSummaryPagePremiumWidget.prototype.verifyRenewalProposalStatus = function (checkStatus) {
        return this.state.renewalProposal != null && this.state.renewalProposal.status === checkStatus;
    };
    AnnualMotorSummaryPagePremiumWidget.prototype.getChangedDrivers = function (driversA, driversB) {
        if (driversB.length > 0) {
            if (driversB.length > 0) {
                var differentDrivers_1 = driversA.map(function (driver) { return driver.personId; });
                var sameDrivers_1 = driversB.filter(function (existingDriver) { return differentDrivers_1.includes(existingDriver.personId); }).map(function (driver) { return driver.personId; });
                return driversB.filter(function (existingDriver) { return !sameDrivers_1.includes(existingDriver.personId); });
            }
            else {
                return driversB;
            }
        }
        return [];
    };
    AnnualMotorSummaryPagePremiumWidget.prototype.getExcessBanner = function (interaction, mtaJourney) {
        var addedDrivers = this.getChangedDrivers(this.state.oldInteraction.additionalDrivers, interaction.additionalDrivers);
        var removedDrivers = this.getChangedDrivers(interaction.additionalDrivers, this.state.oldInteraction.additionalDrivers);
        var supportedProcess = [services_1.INTERACTION_PROCESS_MTA_ADD_PERMANENT_DRIVER, services_1.INTERACTION_PROCESS_MTA_REMOVE_DRIVER];
        var isMTAJourneyForExcessBanner = supportedProcess.some(function (type) { return type === mtaJourney; });
        if (isMTAJourneyForExcessBanner || addedDrivers.length > 0 || removedDrivers.length > 0) {
            return (0, jsx_runtime_1.jsx)(AnnualMotorMtaExcessChangeBanner_1.AnnualMotorMtaExcessChangeBanner, { interaction: interaction });
        }
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
    };
    AnnualMotorSummaryPagePremiumWidget.prototype.getAddDriverWording = function (interaction) {
        var car = interaction.vehicles[0];
        var addedDrivers = this.getChangedDrivers(this.state.oldInteraction.additionalDrivers, interaction.additionalDrivers);
        var additionalDriversNames = addedDrivers.map(function (driver, index) {
            return index === addedDrivers.length - 1 ?
                (0, jsx_runtime_1.jsxs)("span", { children: [driver.firstName, " ", driver.lastName] }, driver.personId) :
                (0, jsx_runtime_1.jsxs)("span", { children: [driver.firstName, " ", driver.lastName, ", "] }, driver.personId);
        });
        return (0, jsx_runtime_1.jsxs)("li", { children: ["Add ", additionalDriversNames, " to ", car.make, ", ", car.model, ", ", car.registrationNumber] });
    };
    AnnualMotorSummaryPagePremiumWidget.prototype.getRemoveDriverWording = function (interaction) {
        var car = interaction.vehicles[0];
        var removedDrivers = this.getChangedDrivers(interaction.additionalDrivers, this.state.oldInteraction.additionalDrivers);
        var removedDriversNames = removedDrivers.map(function (driver, index) {
            return index === removedDrivers.length - 1 ?
                (0, jsx_runtime_1.jsxs)("span", { children: [driver.firstName, " ", driver.lastName] }, driver.personId) :
                (0, jsx_runtime_1.jsxs)("span", { children: [driver.firstName, " ", driver.lastName, ", "] }, driver.personId);
        });
        return (0, jsx_runtime_1.jsxs)("li", { children: ["Remove ", removedDriversNames, " from ", car.make, ", ", car.model, ", ", car.registrationNumber] });
    };
    AnnualMotorSummaryPagePremiumWidget.prototype.getTierChangeWording = function (interaction) {
        var newTier = interaction === null || interaction === void 0 ? void 0 : interaction.coverTier;
        var previousTier = interaction === null || interaction === void 0 ? void 0 : interaction.uistate.previousCoverTier;
        if (!previousTier || newTier === previousTier) {
            return "";
        }
        switch (newTier) {
            case services_1.MOTOR_COVER_TIERS.MOTOR_TIER_3:
                return "Upgrade to our ".concat(services_1.resourcesHelper.PRODUCT_TIER_3, " cover, our highest level of comprehensive car insurance.");
            case services_1.MOTOR_COVER_TIERS.MOTOR_TIER_2:
                if (previousTier !== services_1.MOTOR_COVER_TIERS.MOTOR_TIER_3) {
                    return "Upgrade to our ".concat(services_1.resourcesHelper.PRODUCT_TIER_2, " cover level.");
                }
                else {
                    return "Change your cover level to ".concat(services_1.resourcesHelper.PRODUCT_TIER_2, ".");
                }
            case services_1.MOTOR_COVER_TIERS.MOTOR_TIER_1:
                return "Change your cover level to ".concat(services_1.resourcesHelper.PRODUCT_TIER_1, ".");
            default:
                return "";
        }
    };
    AnnualMotorSummaryPagePremiumWidget.prototype.getUpfrontWording = function (interaction) {
        var upfrontPaymentAmount = (0, commonFunctions_1.getUpfrontPaymentAmount)(interaction.factors);
        var remainingPaymentAmount = (0, commonFunctions_1.getRemainingSpreadAmount)(interaction.factors);
        var upfrontInterestCorrectionRefund = Math.abs(interaction.paymentDetails.instalmentPlan.upfrontInterestCorrectionRefund);
        var upfrontInterestCorrectionRefundCondition = upfrontInterestCorrectionRefund !== null && upfrontInterestCorrectionRefund > 1;
        return (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [upfrontInterestCorrectionRefundCondition &&
                    (0, jsx_runtime_1.jsxs)("p", { className: "margin-top-32", children: ["You'll also receive an upfront refund of ", (0, jsx_runtime_1.jsx)("strong", { children: (0, commonFunctions_1.getAmountToDisplay)(upfrontInterestCorrectionRefund) }), ' ', "due to the interest you paid."] }), upfrontPaymentAmount && this.state.remainingAmountPresent && remainingPaymentAmount &&
                    (0, jsx_runtime_1.jsxs)("p", { className: "margin-top-32", children: ["Pay ", (0, jsx_runtime_1.jsx)("strong", { children: upfrontPaymentAmount }), " upfront now and the remaining balance of ", (0, jsx_runtime_1.jsx)("strong", { children: remainingPaymentAmount }), " by monthly payments."] })] });
    };
    __decorate([
        (0, core_1.lazyInject)(services_1.Types.CustomerPortalService),
        __metadata("design:type", Object)
    ], AnnualMotorSummaryPagePremiumWidget.prototype, "customerPortalService", void 0);
    return AnnualMotorSummaryPagePremiumWidget;
}(plugin_journey_1.WidgetBase));
exports.AnnualMotorSummaryPagePremiumWidget = AnnualMotorSummaryPagePremiumWidget;
//# sourceMappingURL=AnnualMotorSummaryPagePremiumWidget.js.map